import { makeStyles } from '@material-ui/core';
import MuiAccordion from '@material-ui/core/Accordion';
import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import { withStyles } from '@material-ui/core/styles';

import lineHeight from '../../theme/MUI/lineHeight';
import styleGuide from '../../theme/MUI/styleGuide';

export default makeStyles((theme: any) => ({
  root: {
    marginTop: theme.spacing(16),
    alignItems: 'center',
    marginBottom: theme.spacing(9),
    [theme.breakpoints.down('sm')]: {
      marginTop: theme.spacing(8),
      width: '100%',
      margin: theme.spacing(0),
    },
  },
  boxItem: {
    [theme.breakpoints.down('sm')]: {
      minWidth: '0px',
    },
    [theme.breakpoints.up('sm')]: {
      minWidth: '0px',
    },
    [theme.breakpoints.up('md')]: {
      minWidth: '660px',
    },
    [theme.breakpoints.up('xl')]: {
      minWidth: '844px',
    },
    [theme.breakpoints.up('xxl')]: {
      minWidth: '972px',
    },
  },

  title: {
    [theme.breakpoints.down('sm')]: {
      padding: `${theme.spacing(0)} ${theme.spacing(10 / 8)}px`,
    },
    textAlign: 'center',
  },
  container: {
    marginTop: theme.spacing(4),
  },
  imageIcon: {
    padding: `${theme.spacing(20 / 8)}px`,
    paddingLeft: theme.spacing(0),
  },
  gridItem: {
    display: 'flex',
    alignItems: 'center',
    height: `${theme.spacing(72 / 8)}px`,
  },
  gridItemDetail: {
    padding: `${theme.spacing(20 / 8)}px ${theme.spacing(2)}px`,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    boxShadow: `inset 0px -1px 0px #e0e0e0 !important`,
  },
  answerBox: {
    maxWidth: '95%',
  },
  tickContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    color: '#127a81',
  },
}));

// Customization accordion material ui

export const Accordion = withStyles(() => ({
  root: {
    width: '100%',
    boxShadow: `inset 0px -1px 0px #e0e0e0 !important`,
    '&:not(:last-child)': {},
    '&:before': {
      display: 'none',
    },
    '&$expanded': {
      margin: 'auto',
    },
  },
  expanded: {},
}))(MuiAccordion);

export const AccordionSummary = withStyles((theme) => ({
  root: {
    marginBottom: -`${styleGuide.space4}`,
    paddingRight: theme.spacing(2),
    fontWeight: 'bold',
    lineHeight: lineHeight[6],
    '&$expanded': {
      minHeight: 50,
      boxShadow: `0px 16px 5px -8px #e0e0e0`,
    },
  },
  content: {
    margin: '0',
    '&$expanded': {
      margin: '0',
    },
  },
  expanded: {},
}))(MuiAccordionSummary);

export const AccordionDetails = withStyles((theme) => ({
  root: {
    padding: theme.spacing(0),
    display: 'block',
  },
}))(MuiAccordionDetails);
